<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerpt0101" class="chapter" epub:type="part" id="pt01" role="doc-part">
<header id="headerpt0101">
<h1 class="pn"><span aria-label="11" class="page" id="p11" role="doc-pagebreak"></span><a class="xref" href="#/chicondon0005#toc">* I *</a></h1>
<h1 class="pt">Imagining the Economic Other</h1>
</header>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-condon-0007.vue?3597bf58